import { render, staticRenderFns } from "./ReturnGoodsCreation.vue?vue&type=template&id=232e68c0&scoped=true"
import script from "./ReturnGoodsCreation.vue?vue&type=script&lang=js"
export * from "./ReturnGoodsCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "232e68c0",
  null
  
)

export default component.exports